<template>
    <main>
        <div id="content" class="py-4">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-6 col-xl-6 order-2 order-lg-1">
                        <div class="">
                            <div class="mb-3 d-flex align-items-center">
                                <img v-if="!currentMenu.options && icon" :src="icon" class="bill-img bill-img-lg" alt="option">
                                <img v-else-if="!!currentMenuSameProvider && !!currentMenu.image" :src="currentMenu.image"
                                     class="bill-img bill-img-lg" alt="provider">
                                <img v-else-if="currentMenu.icon || currentMenu.image"
                                     :src="currentMenu.icon || currentMenu.image" class="bill-img bill-img-lg" alt="menu">
                                <div :class="{'ml-3' : !!icon}">
                                    <h5 class="font-weight-bold mb-0">
                                        {{ currentTitle }}
                                        <!--<span v-show="currentTitle ==='ZINARA Vehicle Licence' || currentTitle ==='Moovah Vehicle Insurance'" class="badge badge-warning"><small>Beta Testing</small></span>-->
                                    </h5>
                                </div>
                            </div>
                            <slot name="navigation">
                                <horizontal-scroll v-if="currentMenu.options" buttons-class="bg-transparent" class="mb-2">
                                    <template v-for="option in uniqueOptions">
                                        <template v-if="option.name !== ''">
                                            <div class="nav-item d-inline-block" :key="option.name"
                                                 :title="option.name ">
                                                <router-link
                                                    class="nav-link rounded mr-2 mb-2 px-3 d-flex flex-row align-content-center justify-content-between"
                                                    exact-active-class="active"
                                                    :class="{
                                                        active: option.route === $route.fullPath || option.altRoute === $route.fullPath,
                                                        off: serviceDisabled(option)
                                                    }"
                                                    :to="option.route"  @click.native="switchCurrency(option)">
                                                    <img v-if="option.image" class="bill-img" :src="option.image" alt="">
                                                    <span v-else>{{ option.name }}</span>
                                                    <span class="d-flex flex-row align-content-center" v-if="option.image2">
                                                        <b class="ml-1">+</b>
                                                        <img class="bill-img" :src="option.image2" alt="">
                                                    </span>
                                                    <span  class="d-flex flex-row align-content-center" v-if="option.image3">
                                                        <b class="mr-1">+</b>
                                                        <img class="bill-img-sm" :src="option.image3" alt="">
                                                    </span>

                                                </router-link>
                                            </div>
                                        </template>
                                    </template>
                                </horizontal-scroll>
                            </slot>
                        </div>
                        <div class="bg-light shadow-sm rounded p-3 p-sm-4 mb-4 pt-0">
                            <div v-if="currentActiveMenu" class="mb-3 d-flex border-bottom pb-2 align-items-center">
                                <div class="mr-auto">
                                    <h5 class="mb-0 text-black font-weight-bold text-uppercase">
                                        {{ currentProvider }}
                                    </h5>
                                    <!--<small v-if="currentActiveMenu.currencies">{{ currency }} </small>-->

                                    <small v-if="currentActiveMenu.poweredBy">{{ currentActiveMenu.poweredBy }}</small>
                                    <small v-else>{{ currentSubtitle }}</small>
                                </div>
                                <div class="btn-group btn-group-sm">
                                    <a v-if="currentActiveMenu.currencies" class="btn btn-light bg-light-5 btn-sm shadow-none" @click.prevent="" href="#">
                                        <span class="text-muted">Switch to {{ oppositeCurrency }} </span>
                                    </a>
                                    <a v-if="currentActiveMenu.offers" class="badge badge-info text-white p-2 text-2" >
                                        <span>{{ currentActiveMenu.offers }}</span>
                                    </a>
                                    <a :title="`Switch to ${oppositeCurrency}`" v-if="currentActiveMenu.currencies && currentActiveMenu.currencies.includes(oppositeCurrency)" @click="toggleCurrency()" class="btn btn-danger bg-accent btn-sm shadow-none" href="#">
                                        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path
                                                d="M12,18A6,6 0 0,1 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12A8,8 0 0,0 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6A6,6 0 0,1 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12A8,8 0 0,0 12,4Z"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div v-if="serviceDisabled(currentActiveMenu)" class="text-center alert alert-danger">
                                <strong>NOTE:</strong> {{ currentActiveMenu.disabledMessage || 'The service is unavailable at the moment. Please try again later.' }}
                                <button v-if="currentActiveMenu.disabledAction" class="btn btn-outline-primary btn-sm mt-3 shadow-none" @click="currentActiveMenu.disabledAction.action">
                                    {{ currentActiveMenu.disabledAction.text }}
                                </button>
                            </div>
                            <slot v-else name="content">
                                <keep-alive>
                                    <transition name="slide-in-left">
                                        <router-view></router-view>
                                    </transition>
                                </keep-alive>
                            </slot>

                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-6 d-flex align-items-start order-1 order-lg-2 pb-3">
                        <ad-scroll   class="mb-2 d-block d-sm-block d-md-none"></ad-scroll>
                        <div
                            ref="stickyBlock"
                            class="sticky"
                            :class="{ 'is-sticky': isSticky, 'is-absolute': isAbsolute }"
                        >
                            <ad-carousel></ad-carousel>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div ref="contentBlock" class="content">
            <slot></slot>
        </div>

    </main>
</template>

<script>
import {navigationComponents} from "../../core/navigation-components";
import {appDataMixin} from "../../core/data/global";
import HorizontalScroll from "../core/horizontal-scroll.vue";
import AdScroll from "../core/AdScroll.vue";
import AdCarousel from "../core/AdCarousel.vue";

export default {
    name: "bill-shell",
    components: {HorizontalScroll,AdScroll, AdCarousel},
    mixins: [navigationComponents, appDataMixin],
    props: [
        'title',
        'defaultTitle',
        'subtitle',
        'defaultSubtitle',
        'hideCheckTransaction'
    ],
    computed: {
        uniqueOptions() {
            const seen = new Set();
            return this.currentMenu.options.filter(el => {
                const duplicate = seen.has(el.name);
                seen.add(el.name);
                return !duplicate;
            });
        },
        menuItem() {
            return this.menu.find(m => this.$route.path.startsWith(m.route)) || {};
        },
        currentMenu() {
            return this.services.find(m => this.$route.path.startsWith(m.route)) || {}
        },
        currentMenuSameProvider() {
            return (this.currentMenu.options || []).every(s => !s.provider || s.provider === this.currentMenu.provider) && this.currentMenu.image
        },
        currentActiveMenu() {
            return this.flatServices[this.$route.fullPath]
        },
        currentTitle() {
            return this.title ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name) ||
                this.defaultTitle
        },
        currentSubtitle() {
            return this.subtitle ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name) ||
                this.defaultSubtitle
        },
        currentProvider() {
            return (this.currentActiveMenu && this.currentActiveMenu.provider) ||
                (this.currentMenu && this.currentMenu.provider)
        },
        icon() {
            return (this.currentActiveMenu && this.currentActiveMenu.image) ||
                (this.currentActiveMenu && this.currentActiveMenu.icon) ||
                (this.currentMenu && this.currentMenu.image) ||
                (this.currentMenu && this.currentMenu.icon)
        }
    },
    data() {
        return {
            isSticky: false,
            isAbsolute: false,
        };
    },
    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.$nextTick(() => {
        })
        window.addEventListener("scroll", this.handleScroll);

    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            try {
                const { stickyBlock, contentBlock } = this.$refs;

                if (!(stickyBlock && stickyBlock.$el && contentBlock && contentBlock.$el)) {
                    return;
                }

                const { offsetTop: stickyTop, clientHeight: stickyHeight } = stickyBlock.$el;
                const {offsetTop: contentTop} = contentBlock.$el;

                if (window.scrollY > stickyTop) {
                    if (window.scrollY > contentTop - stickyHeight) {
                        this.isSticky = false;
                        this.isAbsolute = true;
                    } else {
                        this.isSticky = true;
                        this.isAbsolute = false;
                    }
                } else {
                    this.isSticky = false;
                    this.isAbsolute = false;
                }
            } catch (error) {
                /*console.error('handleScroll encountered an error:', error.message);*/
            }
        }
    }
}
</script>

<style scoped>
.sticky {
    position: sticky;
    top: 90px;
}

.is-sticky {
    position: fixed;
    top: 0;
}

.is-absolute {
    position: absolute;
    top: auto;
    bottom: 0;
}
@media (max-width: 768px) {
    .mobile-ad {
        height: 155px;
    }

}

.nav-link {
    color: rgba(0, 0, 0, 0.5) !important;
    border-radius: 0;
    vertical-align: bottom;
    background-color: #fff !important;
}

.nav-link.active {
    background-color: var(--primary-color) !important;
    border-left: 4px solid var(--accent-color) !important;
    color: #fff !important;
}

.nav-link.active img {
    filter: brightness(0) invert(1);
}

.bill-img {
    height: 24px;
    width: calc(22px * 4);
    object-fit: contain;
}
.bill-img-sm {
    height: 24px;
    object-fit: contain;
}

.bill-img.bill-img-lg {
    height: 56px;
    width: auto;
    max-width: 64px;
    border: 1px #eee solid;
    padding: 0.4rem;
    object-fit: contain;
    background-color: rgba(255, 255, 255, 0.45);
    border-radius: 6px;
}

.currency-flag, .icon {
    height: 12px;
    object-fit: contain;
}

.currency-flag {
    height: 12px;
}

.icon {
    height: 16px;
}
</style>
